/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ShopQueryResultItem from './ShopQueryResultItem';

/**
 * The ShopOutputItems model module.
 * @module model/ShopOutputItems
 * @version 1.0
 */
class ShopOutputItems {
    /**
     * Constructs a new <code>ShopOutputItems</code>.
     * @alias module:model/ShopOutputItems
     */
    constructor() { 
        
        ShopOutputItems.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShopOutputItems</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShopOutputItems} obj Optional instance to populate.
     * @return {module:model/ShopOutputItems} The populated <code>ShopOutputItems</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShopOutputItems();

            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [ShopQueryResultItem]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/ShopQueryResultItem>} items
 */
ShopOutputItems.prototype['items'] = undefined;






export default ShopOutputItems;

